import { defineNuxtPlugin, ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from '#imports';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp
    .provide(ID_INJECTION_KEY, {"prefix":1024,"current":0})
    .provide(ZINDEX_INJECTION_KEY, {"current":0});
})
